import { useRef } from 'react'
import Boat from '../../assets/images/Photo/boat.jpg'
import Sharky from '../../assets/images/Photo/sharky.png'
import Lab from '../../assets/images/Photo/lab.jpg'
import { ReactComponent as CircleText } from '../../assets/images/Doodles/circleText.svg' 
import SharkyWaving from '../../assets/images/Sharky/Sharky_Waving.png'
import './About.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { useGSAP } from '@gsap/react'
import { useTranslation, Trans } from 'react-i18next'
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

function AboutDesktop() {
    const aboutDesktopRef = useRef();
    const { t, i18n } = useTranslation(['common', 'navigation']);
    
    useGSAP(() => {
        const ctx = gsap.context(() => {
            // Obtener todos los elementos con la clase
            const textElements = gsap.utils.toArray(".about-text-appear");
            
            textElements.forEach((element) => {
                // eslint-disable-next-line
                let split = SplitText.create(element, {
                    type: "lines",
                    autoSplit: true,
                    onSplit: (self) => {
                        return gsap.from(self.lines, {
                            scrollTrigger: {
                                trigger: element, // Cada elemento es su propio trigger
                                start: "top 80%",
                                end: "+=100",
                                scrub: true,
                                markers: false //only dev
                            },
                            y: 50,
                            autoAlpha: 0,
                            stagger: 0.05
                        });
                    }
                });  
            });
        });

    return () => ctx.revert(); // Limpieza automática
    }, {scope: aboutDesktopRef, dependencies: [i18n.language]});

    return(
        <div ref={aboutDesktopRef} className='section-about bg-bluekali-navy-blue flex min-h-dvh items-start justify-between pl-16 pt-24 overflow-hidden w-full' id='section-about'>
            <div className='flex flex-col w-1/2 h-5/6 justify-start'>
                <div className=' flex flex-col justify-start'>
                <div className='flex justify-between h-[475px]'>
                    <div className='w-full flex flex-col justify-between'>
                        <h1 className='md:text-5xl font-bold'>{t('about.title')}</h1>
                        <div className='mt-4'>
                            {/* <div className='about-text-appear'> */}
                                <Trans 
                                    i18nKey="about.desc"
                                    components={{ bold: <span className="font-bold"/> }} 
                                    
                                />
                            {/* </div> */}
                            
                            <img alt='' className='h-60 w-full object-cover rounded-xl mt-5 custom-shadow' src={Lab}/>
                        </div>
                    </div>
                    <div className='w-16'/>
                    <div className='w-full flex flex-col justify-between'>
                        <img alt='' className='h-[350px] w-full object-cover rounded-xl custom-shadow object-bottom' src={Boat}/>
                        <div className='mt-auto'/>
                        <h3 className='about-text-appear w-full pt-3 font-black'>{t('about.mission_title')}</h3>
                        <h3 className='about-text-appear w-full pt-1'>{t('about.mission')}</h3>
                    </div>
                </div>
                
            </div>
            <h3 className='w-3/4 mt-40'>{t('about.under_text')}</h3>
            </div>
            

            <div className='flex flex-col justify-between h-dvh pt-0 w-1/2 pr-8 overflow-hidden'>
                <div className='z-20 p-8 pt-0'>
                    <img alt='' className='h-[300px] w-full object-cover rounded-xl custom-shadow object-[center_80%]' src={Sharky}/>
                    <h3 className='about-text-appear w-3/4 mt-5 font-black'>{t('about.vision_title')}</h3>
                    <h3 className='about-text-appear w-3/4 mt-1'>{t('about.vision')}</h3>
                </div>

                {/* <div className='absolute z-10'>
                    <div className="absolute bottom-0 right-0 transform translate-y-0 md:translate-y-16 lg:translate-y-1/4 h-[300px] w-[300px] md:w-[400px] md:h-[400px] lg:w-[500px] lg:h-[500px] overflow-hidden flex-shrink-0">
                        <CircleText className='spin-slow h-auto'/>
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-12">
                            <img src={SharkyWaving} alt='' className='w-24 lg:w-44 scale-x-[-1]'/>
                        </div>
                    </div>
                </div> */}

                <div className='relative flex w-full h-full justify-center md:items-center lg:items-end overflow-hidden'>
                    <CircleText className='absolute w-3/4 transform lg:translate-y-1/3 md:spin-slow lg:spin-slow-translate'/>
                    <img src={SharkyWaving} alt='' className='w-1/3 scale-x-[-1] rotate-12 transform lg:translate-y-1/3'/>
                </div>
            </div>
            
        </div>
    );   
}

export default AboutDesktop;